module.exports.EXTERNAL_NAME = 'miManifestClientV1'